<template>
  <div>
    <h3>Building Surveys</h3>
     <div class="wrapper">
      <div  class="row row-wider">
        <div class="col-md-12">
            <loader v-if="loading"></loader>
            <div class="col-md-2 form-group" v-if="isUserRc && type ==='todo'">
                <div class="pull-right">
                    <input class="form-check-input" type="checkbox" v-model="searchDto.showAll" style="width: 20px; height: 20px;">
                </div>
                <div class="pull-right">
                    <label class="form-check-label" for="showAll">Show All&nbsp;</label>
                </div>
            </div>
            <div>
                <v-client-table :data="gridSpec.tableData" :columns="gridSpec.columns" :options="gridSpec.options" ref="gridTable">
                <template slot="edit" slot-scope="props">
                    <div style="text-align: center;">
                        <!-- <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editRow(props.row.buildingSurveyId)"></a> -->
                        <router-link :to="{ path: '/BuildingSurvey/' + props.row.buildingSurveyId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                    </div>
                </template>
                </v-client-table>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import buildingSurveyService from '@/services/buildingSurveyService'

import loader from '../components/Loader.vue'

export default {
    components: {
        loader
    },
    props: {
        type: {
            type: String,
            default: 'search'
        },
        isUserRc: { default: false }
    },
    data () {
        return {
            isDebug: false,
            loading: true,
            searchDto: {
                showAll: false
            },
            gridSpec: {
                columns: ['edit', 'workflowStatusDescription', 'surveyName', 'createdDate'],
                tableData: [],
                options: {
                    dateFormat: 'YYYY-MM-DD',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        edit: 'View/Edit',
                        createdDate: 'Created Date',
                        workflowStatusDescription: 'Status',
                        surveyName: 'Survey Name'
                    },
                    orderBy: {
                        ascending: false,
                        column: 'createdDate'
                    }
                }
            }
        }
    },
    watch: {
        'searchDto.showAll': function () {
            this.loadData()
        }
    },
    mounted () {
        this.log('mounted')
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'BuildingReconForms', message)
        },
        loadData () {
            this.log('loadData, type: ' + this.type)

            this.loading = true

            if (this.type === 'search') {
                buildingSurveyService.search(this.$http, this.searchDto).then(response => {
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else if (this.type === 'todo') {
                buildingSurveyService.todo(this.$http, this.searchDto).then(response => {
                    this.gridSpec.tableData = response.data
                    this.loading = false
                })
            } else {
                this.log('buildingReconForms.loadData - unknown type: ' + this.type)
            }
            this.$refs.gridTable.setData
        },
        editRow (id) {
            this.log('editRow: ' + id)
            this.$router.push('/BuildingSurvey/' + id)
        }
    }
}
</script>



// WEBPACK FOOTER //
// BuildingSurveys.vue?26efe5ce